// Mal Kabul Okutma (el terminali) ekranı kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.receivingScan';

export const wmsReceivingScanGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Mal kabul nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Gelen ürünleri okutur, miktarı kontrol eder, sonra raflara yerleştirirsiniz. Akıllı depoda stok, ürün rafa yerleştirildiğinde artar. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'MAL KABUL ve Ayrıntı rozeti'),
    form: t(`${G}.regions.form`, 'ÜRÜN OKUTUN / SON OKUTULAN'),
    list: t(`${G}.regions.list`, 'KABUL EDİLEN ÜRÜNLER'),
    footer: t(`${G}.regions.footer`, 'İptal / Yerleştir / Tamamla'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Ürünü okutun, miktarı onaylayın'),
      text: t(`${G}.s1.text`, 'Ürün barkodunu "ÜRÜN OKUTUN" kutusuna okutun. Her okutma 1 adet ekler; aynı ürünü tekrar okutursanız miktarı artar. "SON OKUTULAN" kartında miktarı - / + ile ya da yazarak düzeltip "KABUL ET"e basın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Ürün için önerilen raf varsa kartın altında haritada gösterilir.'),
        t(`${G}.s1.tip2`, 'Okutma ve kabul stok miktarını henüz değiştirmez; stok, ürün rafa yerleştirildiğinde artar.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Varyant seçin'),
      text: t(`${G}.s2.text`, 'Barkod birden fazla varyanta (ör. renk, beden) aitse "Varyant Seçin" penceresi açılır. Elinizdeki ürünün varyantını seçin; yanlış seçim stoğu yanlış varyanta yazar.'),
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Bulunamayan ürün'),
      text: t(`${G}.s3.text`, 'Okutulan barkod stokta kayıtlı değilse "Ürün Bulunamadı" penceresi açılır. Ürün Adı (zorunlu), Satış Fiyatı ve KDV (varsayılan %20) girip "Ekle ve Yerleştir"e basın: okutulan barkodla yeni stok kartı açılır, ürün kabul edilir ve yerleştirme ekranına geçilir. Kart açmak istemiyorsanız "Hayır" deyin.'),
      tips: [
        t(`${G}.s3.tip1`, 'Hızlı açılan kartta birim "adet", stok kodu otomatik verilir. Maliyet, kategori gibi bilgileri sonra stok kartından tamamlayın.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Kabul listesini kontrol edin'),
      text: t(`${G}.s4.text`, '"KABUL EDİLEN ÜRÜNLER" listesinde her ürünün miktarı, lokasyonu ve durumu (Kabul / Yerleştirildi) görünür. Miktarı - / + ile düzeltebilir, çöp kutusuyla ürünü listeden çıkarabilirsiniz. Yerleştirilmiş satır değiştirilemez ve silinemez.'),
      tips: [
        t(`${G}.s4.tip1`, 'Üstteki "Kabul: … ürün • Ayrıntı" rozetine dokunursanız ürün çeşidi, toplam adet ve yerleştirilen sayısıyla özet açılır.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Rafa yerleştirin'),
      text: t(`${G}.s5.text`, 'Satırdaki konum simgesi tek ürünü, "TOPLUCA YERLEŞTİR" bekleyen tüm ürünleri yerleştirme ekranına götürür. Önerilen lokasyonu görür, raftaki lokasyon barkodunu okutursunuz; "TÜM ÖNERİLERİ KABUL ET" hepsini önerilen raflara yerleştirir. Yerleştirince miktar o rafın stoğuna eklenir ve stok hareketi yazılır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Öneri sırası: ürün daha önce hangi raftaysa orası, yoksa aynı ürünün diğer varyantlarının rafı, yoksa boş raf, yoksa en az dolu raf.'),
        t(`${G}.s5.tip2`, 'Yalnız aktif ve toplanabilir raf / bölme lokasyonlarına yerleştirilebilir.'),
        t(`${G}.s5.tip3`, 'Stok bekleyen siparişler varsa yerleştirmeden sonra yeniden kontrol edilir; stok yetiyorsa toplamaya açılır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Teslimatı tamamlayın veya iptal edin'),
      text: t(`${G}.s6.text`, '"TESLİMAT TAMAMLA" mal kabulü kapatır; akıllı depoda bütün ürünler yerleştirilmiş olmalıdır, değilse yerleştirilmemiş ürünlerin adları gösterilir. "MAL KABULÜ İPTAL ET" mal kabulü tamamen iptal eder: o ana kadar yerleştirilen ürünler stoktan geri alınır. İptal gerekçesi isteğe bağlıdır; işlem geri alınamaz.'),
    },
  ],
});
